import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { FileUpload } from "primereact/fileupload";

// Inputs
import { TextInputField, CalendarField, DropDownField, Button } from '../../../helpers';

// redux
import { raiseToast } from '../../../services/redux/reducers/toast/toast';
import { getUploadedFileObj } from '../../../utils';
import FileViewAndRemove from '../../../common/FileViewAndRemove';


const TrackingDetails = (props) => {

    const dispatch = useDispatch()

    const { editedTrackingDetails, statesList, previousTrackingDetails } = props

    let [logisticPartners, setLogisticPartners] = useState([])

    useEffect(() => {
        if (props.logisticPartners) {

            const uniquePartners = {}
            let uniqueLogisticsPartnersData = []
            props.logisticPartners?.map(eachLogisticPartner => {
                let relatedState = statesList.find(eachState => eachState.stateId === eachLogisticPartner.stateId)
                if (relatedState) {
                    const partnerNameWithState = eachLogisticPartner.partnerName + "_" + relatedState.stateName
                    if (!uniquePartners[partnerNameWithState]) {
                        uniquePartners[partnerNameWithState] = true
                        uniqueLogisticsPartnersData.push({ ...eachLogisticPartner, partnerNameWithState })
                    }
                } else {
                    uniqueLogisticsPartnersData.push({ ...eachLogisticPartner, partnerNameWithState: eachLogisticPartner.partnerName })
                }
            })
            setLogisticPartners(uniqueLogisticsPartnersData)
        }
    }, [props.logisticPartners])

    const handleTrackingDetailsInputChange = (event) => {
        editedTrackingDetails[event.target.name] = event.target.value
        props.setEditedTrackingDetails({ ...editedTrackingDetails })
    }

    const fileUploadHandler = async ({ files, options }) => {
        const { fileArr, error, errorMsg } = await getUploadedFileObj({ files, options })
        if (error) {
            return dispatch(raiseToast({ severity: 'error', detail: errorMsg, life: 3000 }))
        }
        const fileObj = fileArr[0]
        uploadTrackingDocument(fileObj.objectURL, fileObj.name, fileObj.dataURI)
    }

    const uploadTrackingDocument = async (fileURL, fileName, dataURI) => {
        let data = {
            url: fileURL,
            documentName: "DISPATCH_TRACKING",
            fileName,
            dataURI,
            objectURL: fileURL,
        }
        editedTrackingDetails.trackingDocPath = data
        props.setEditedTrackingDetails({ ...editedTrackingDetails })
    }

    const removeTrackingDocument = () => {
        editedTrackingDetails.trackingDocPath = null
        props.setEditedTrackingDetails({ ...editedTrackingDetails })
    }

    return (
        <>
            <div className="flex flex-row justify-content-between">
                <h4 className="mt-0 mb-2">Tracking Details</h4>
            </div>
            <div className="">
                <div className="grid">
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <DropDownField name="logisticPartnerId" labelText="Logistic Partner" options={logisticPartners} optionLabel="partnerNameWithState" optionValue="logisticPartnerId" value={editedTrackingDetails?.logisticPartnerId} onChange={(event) => handleTrackingDetailsInputChange(event)} errorMessage={props.trackingDetailsFormErrors?.logisticPartnerId} required disabled={previousTrackingDetails?.logisticPartnerId && !editedTrackingDetails.isEditable} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <TextInputField name="trackingNumber" labelText="Tracking Number" value={editedTrackingDetails?.trackingNumber} onChange={(event) => handleTrackingDetailsInputChange(event)} errorMessage={props.trackingDetailsFormErrors?.trackingNumber} required disabled={previousTrackingDetails?.trackingNumber && !editedTrackingDetails.isEditable} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <TextInputField name="trackingOrderLink" labelText="Tracking Order Link" value={editedTrackingDetails?.trackingOrderLink} onChange={(event) => handleTrackingDetailsInputChange(event)} errorMessage={props.trackingDetailsFormErrors?.trackingOrderLink} required disabled={previousTrackingDetails?.trackingOrderLink && !editedTrackingDetails.isEditable} />
                    </div>
                    <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                        <CalendarField name="expectedDeliveryDate" labelText="Expected Delivery Date" placeholder="" minDate={new Date()} value={editedTrackingDetails?.expectedDeliveryDate ? new Date(editedTrackingDetails?.expectedDeliveryDate) : null} onChange={(event) => handleTrackingDetailsInputChange(event)} required errorMessage={props.trackingDetailsFormErrors?.expectedDeliveryDate} disabled={previousTrackingDetails?.expectedDeliveryDate && !editedTrackingDetails.isEditable} />
                    </div>
                </div>
                <div className="grid upload-file mt-2">
                    <div className="flex align-items-center col-12 mb-2">
                        <label htmlFor="trackingDocPath" className="text-xs mb-1 mr-2">Tracking Doc<span style={{ color: "red" }} className="from-required">*</span>: </label>
                        {
                            !editedTrackingDetails.trackingDocPath || editedTrackingDetails.isEditable ?
                                <div className="mr-2">
                                    <FileUpload mode="basic" name="trackingDocPath" accept="image/pdf/*" customUpload auto multiple chooseLabel="Upload Document" uploadHandler={(files) => fileUploadHandler(files)} />
                                </div>
                                : null
                        }
                        {
                            editedTrackingDetails.trackingDocPath ?
                                typeof (editedTrackingDetails.trackingDocPath) === 'string' ?
                                    <div className='mb-1'>
                                        <FileViewAndRemove doc={{url: editedTrackingDetails?.trackingDocPath}} />
                                    </div>
                                    :
                                    <FileViewAndRemove doc={{url: editedTrackingDetails?.trackingDocPath}} showRemove handleRemoveDoc={removeTrackingDocument} />
                                : null
                        }
                    </div>
                </div>
            </div>
        </>
    )
}

export default TrackingDetails